<template>
  <main-layout>
    <v-layout wrap>
      <v-flex row xs12 class="justify-center my-n6">
        <v-img src="../assets/logo.png" max-width="22em"></v-img>
      </v-flex>

      <v-flex xs12 class="mb-4">
        <v-card
          elevation="32"
          :raised="true"
          class="text-justify mb-4">

          <!--<v-card-title class="align-end fill-height">About</v-card-title>-->
          <v-card-text class="mb-n5">
            <p>Currently working as a <a href="http://www.linkedin.com/in/cyrilleberliat" target="_blank">Product Manager</a> for <a href="http://www.google.com/about/" target="_blank">Google Inc.</a> in New York City, I value data-driven decisions and out-of-the-box solutions. I am passionate about technology, especially mobile, and how our societies organize themselves. My hobbies include <a href="https://cyrille.berliat.fr//#/photographer">photography</a> while traveling, <a href="http://curare.berliat.fr" target="_blank">news curation</a> and <a href="https://cyrille.berliat.fr/#/maker">personal maker projects</a>.</p>
            <p>My main strengths are: understanding complex systems, adaptability, and turning chaos into order.</p>
            <p>My education and experience intersect both technical and business environments (MSc. Eng. from <a href="http://www.upm.es/internacional" target="_blank">Universidad Politécnica de Madrid</a>, MS Strategy &amp; Management from <a href="http://www.essec.edu/discover-essec.html" target="_blank">ESSEC Business School</a>). I thrive in roles composed of these 2 dimensions.</p>
            <p>Starting as a software developer, I felt I needed to connect more with my users, resulting in several freelancing and a Android Market User support experiences. But I've realized along the way what my mission should be: leverage technology to solve users' problems at scale -- hence the Product Management focus.</p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        v-for="c in this.$router.options.routes.filter(c => c.icon != undefined)"
        :key="c.id"
        xs12
        md6>
        <v-card
          :outlined="true"
          elevation="32"
          :raised="true">
          <router-link :to="c.path">
            <v-img
              :class="$vuetify.breakpoint.smAndDown ? '' : 'blurred'"
              height="250px"
              :src="c.img"
            >
              <v-card-title class="picture_label">
                <v-icon class="white--text">{{ c.icon }}</v-icon>
                <span>&nbsp; {{ c.title }}</span>
              </v-card-title>
            </v-img>
          </router-link>
        </v-card>
      </v-flex>
    </v-layout>
  </main-layout>
</template>

<script>
  import MainLayout from '../layouts/Main.vue'

  export default {
    name: "Home",  
    components: {
      MainLayout
    },
    data: () => ({})
  }
</script>

<style>
  .blurred .v-image__image {
      filter: blur(2px);
      -webkit-filter: blur(2px);
      -moz-filter: blur(2px);
       -o-filter: blur(2px);
      -ms-filter: blur(2px);
  }

  .blurred:hover .v-image__image {
      filter: blur(0px);
      -webkit-filter: blur(0px);
      -moz-filter: blur(0px);
      -o-filter: blur(0px);
      -ms-filter: blur(0px);
  }

  .picture_label {
    width: 100%;
    color: white;
    background: #12579b99;
    margin: 0px;
    padding: 5px;
    padding-left: 10px;
    text-align: left;
    position: absolute;
    bottom: .5em;
    font-size: 1.5em;
    font-weight: 400;

    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    left: 0;
  }

</style>